import React, { forwardRef } from 'react';
import AddBox from '@material-ui/icons/AddBox';
import Check from '@material-ui/icons/Check';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Edit from '@material-ui/icons/Edit';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Remove from '@material-ui/icons/Remove';
import ViewColumn from '@material-ui/icons/ViewColumn';
import Delete from '@material-ui/icons/Delete';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

export const years = [2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030];
export const newYears = [2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030];
export const nckPortfolio = { stratId: 4, portfId: 9 };
export const range = (start, end) => (start && end ? Array((end < start ? start : end) - start + 1).fill().map((_, idx) => start + idx) : []);

export const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <Search style={{ width: 16 }} {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  HelpOutlineIcon: forwardRef((props, ref) => <HelpOutlineIcon {...props} ref={ref} />),
};
export const styledTable = {
  maxWidth: '100%',
  marginTop: 32,
};
export const styledContainer = {
  display: 'flex',
  zIndex: 11,
  position: 'relative',
  top: 84,
  width: 370,
  marginTop: -90,
};
export const styledTableHeading = {
  textAlign: 'left', marginBottom: 12,
};
// Получить случайную строку по типу uid с заданой длиной
export const makeUID = (length) => {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'; // length 62
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * 62));
  }
  return result;
};
export const stepScroll = {
  spy: true,
  smooth: false,
  duration: 300,
  className: 'step-scroll-box-item',
  activeClass: 'active',
  offset: -110,
};
export const mBStyles = {
  backgroundColor: '#dc3545',
  // transform: "rotate(45deg)",
  width: 'auto',
  height: 38,
  borderRadius: '0.25rem',
  padding: '6px 12px',
};
export const YesLookup ={
  1:'Да',
  0:'Нет'
}
export const yseLookupFiltering = (term,rowData,key) => {
  return term.length === 0 || !key || (term[0]==='1' && rowData[key]) || (term[0]==='0' && !rowData[key])
}